import { render, staticRenderFns } from "./registration.vue?vue&type=template&id=048981e8&scoped=true&lang=pug&"
import script from "./registration.vue?vue&type=script&lang=ts&"
export * from "./registration.vue?vue&type=script&lang=ts&"
import style0 from "./registration.vue?vue&type=style&index=0&id=048981e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.9.8_vd7qwssw5i3h3fjzjs5bz4d2ha/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048981e8",
  null
  
)

export default component.exports